import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { FaExpandArrowsAlt } from "react-icons/fa";
import "./LayoutFixModal.css";

/**
 * Modal reativo de correção de layout (ticket 14).
 *
 * Aparece automaticamente quando o builder detecta ações sobrepostas ao abrir
 * um bot antigo (cards ficaram maiores na nova UI). Oferece aplicar o
 * "Espalhar" uma única vez. Não é reaberto pelo usuário — é só reativo.
 *
 * Renderizado via portal em document.body para escapar do stacking context da
 * topbar (mesma lição do WhatsNew).
 */
export default function LayoutFixModal({ open, onApply, onClose }) {
	// ref para não recriar o listener a cada render (onClose muda por render).
	const onCloseRef = useRef(onClose);
	onCloseRef.current = onClose;

	useEffect(() => {
		if (!open) return;
		const handler = (e) => {
			if ((e.key || "").toLowerCase() === "escape") onCloseRef.current?.();
		};
		window.addEventListener("keydown", handler);
		return () => window.removeEventListener("keydown", handler);
	}, [open]);

	if (!open) return null;

	return ReactDOM.createPortal(
		<div className="layoutfix__backdrop" onClick={onClose}>
			<div
				className="layoutfix__modal"
				role="dialog"
				aria-modal="true"
				aria-label="Interface atualizada"
				onClick={(e) => e.stopPropagation()}
			>
				<div className="layoutfix__badge">
					<FaExpandArrowsAlt />
				</div>
				<h2 className="layoutfix__title">Interface atualizada ✨</h2>
				<p className="layoutfix__text">
					Os cards das ações ficaram maiores nesta nova versão, e algumas ações
					deste fluxo acabaram <strong>sobrepostas</strong>. Quer aplicar um
					espaçamento automático agora? Você poderá revisar e salvar depois.
				</p>
				<div className="layoutfix__actions">
					<button
						type="button"
						className="layoutfix__ghost"
						onClick={onClose}
					>
						Agora não
					</button>
					<button type="button" className="layoutfix__cta" onClick={onApply}>
						Aplicar espaçamento
					</button>
				</div>
			</div>
		</div>,
		document.body
	);
}
